import { Component, OnInit, Output, EventEmitter, Input, HostListener, ElementRef } from '@angular/core';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { RejectionReasonComponent } from '../modals/rejection-reason/rejection-reason.component';
import { OrderHistoryComponent } from '../modals/order-history/order-history.component';
import { OrderOtoComponent } from '../modals/order-oto/order-oto.component';
import { OrderService } from '@teem/app/core/services/order.service';
import { LoaderService } from '@teem/app/core/services/loader.service';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})
export class OrderDetailComponent implements OnInit {
  @Output() selectedOrder: EventEmitter<any> = new EventEmitter();
  @Output() updateOrderStatuses: EventEmitter<any> = new EventEmitter();
  @Output() orderAction: EventEmitter<any> = new EventEmitter();
	@Input() order;
  statuses: any;
  possibleStatuses: any;
  // possibleStatuses: string[] = [ 'pending', 'preparing', 'ready_to_pickup', 'picked_up', 'out_for_delivery', 'completed'];
  endStatuses: string[] = ['completed', 'rejected', 'canceled', 'declined', 'delivery_ended', 'converted_to_invoice', 'delivered'];

  constructor(
    private modalService: NgbModal,
    private elem: ElementRef,
    private router: Router,
    private orderService: OrderService,
    private loaderService: LoaderService,
    private clipboard: Clipboard
  ) { }

  ngOnInit(): void {
    this.possibleStatuses = this.order?.possible_statuses;
    this.statuses = this.order?.statuses;
  }

  get googleMaplocation() {
  	return `https://maps.google.com/maps?q=${this.order.latitude}, ${this.order.longitude}&description=${this.order.city_name}&z=15&output=embed`;
  	// return `https://maps.google.com/maps?q=${(this.order.district_name +', ' + this.order.city_name + ', Saudi Arabia')}&z=15&output=embed`;
  }

  getStatusesToDisplay(): string[] {

    // Check if 'canceled' or 'declined' is present in the statuses
    const hasCanceledOrDeclined = this.statuses.some(item => item.status === 'canceled' || item.status === 'declined' || item.status === 'rejected' || item.status === 'expired');

    // Determine the index of the last possible status to display before 'canceled' or 'declined'
    const lastPossibleIndex = this.possibleStatuses.findIndex(status =>
      this.statuses.some(item => item.status === status)
    );
    
    if (hasCanceledOrDeclined) {
      // Show statuses up to and including the last status present in `statuses`, and then add 'canceled' or 'declined'
      const statusesToShow = this.possibleStatuses.slice(0, lastPossibleIndex + 1);
      
      if (this.statuses.some(item => item.status === 'canceled')) {
        statusesToShow.push('canceled');
      }
      if (this.statuses.some(item => item.status === 'declined')) {
        statusesToShow.push('declined');
      }
      if (this.statuses.some(item => item.status === 'rejected')) {
        statusesToShow.push('rejected');
      }
      if (this.statuses.some(item => item.status === 'expired')) {
        statusesToShow.push('expired');
      }
      return statusesToShow;
    } else {
      // Otherwise, show all possible statuses
      return this.possibleStatuses;
    }
  }

  // Get the date and time for a given status
  getDateTime(status: string): string | null {
    const item = this.statuses.find(item => item.status === status);
    return item ? item.created_at : null;
  }

  updateOrderStatus(action, uuid) {
    Swal.fire({
      icon:'info',
      title: i18n.are_you_sure,
      text: i18n.order.you_want_update_status,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: '#ee3a7a',
      confirmButtonText:
      i18n.order.update_status,
      cancelButtonText:
        i18n.cancel
    }).then(result => {
      if (result.value) {
        this.updateOrderStatuses.emit({ uuid: uuid, action: action });
      }
    });
  }

  orderActions(action, uuid, from = null) {
    switch (action) {
      case "resend_invoice":
        this.orderAction.emit({ uuid: uuid, action: action });
        break;
      case "accept":
        Swal.fire({
          title: i18n.are_you_sure_want_accept_order,
          icon: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#ee3a7a',
          confirmButtonText:
            i18n.accept_order,
          cancelButtonText:
            i18n.cancel
        }).then(result => {
          if (result.value) {
            this.orderAction.emit({ uuid: uuid, action: action, from: from });
          }
        });
        break;
      case "delete":
          Swal.fire({
            icon: 'info',
            title: i18n.order.are_you_sure_want_delete_order,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: '#ee3a7a',
            confirmButtonText:
              i18n.order.delete_order,
            cancelButtonText:
              i18n.cancel
          }).then(result => {
            if (result.value) {
              this.orderAction.emit({ uuid: uuid, action: action });
            }
          });
          break;
      case "cancel":
        Swal.fire({
          title: i18n.order.are_you_sure_want_cancel_order,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#ee3a7a',
          confirmButtonText:
            i18n.order.cancel_order,
          cancelButtonText:
            i18n.cancel
        }).then(result => {
          if (result.value) {
            this.orderAction.emit({ uuid: uuid, action: action });
          }
        });
        break;
      case "rejected":
        const modalRef = this.modalService.open(RejectionReasonComponent);
        console.log(modalRef.componentInstance)
        modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "rejection-modal";
        modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.classList.add("quotation-modal");
        modalRef.componentInstance.orderAction = this.orderAction;
        modalRef.componentInstance.orderStatus = 'rejected';
        modalRef.componentInstance.orderUuid = uuid;
        modalRef.componentInstance.orderFrom = from;
        modalRef.result.then(data => {

        }, fallbackResult => {

        })
        break;
      case "request_declined":
        const modalRefDeclined = this.modalService.open(RejectionReasonComponent);
        console.log(modalRefDeclined.componentInstance)
        modalRefDeclined.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "rejection-modal";
        modalRefDeclined.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.classList.add("quotation-modal");
        modalRefDeclined.componentInstance.orderAction = this.orderAction;
        modalRefDeclined.componentInstance.orderStatus = 'request_declined';
        modalRefDeclined.componentInstance.orderUuid = uuid;
        modalRefDeclined.result.then(data => {

        }, fallbackResult => {

        })
        break;
      case "create_logistiq":
        Swal.fire({
          title: 'Create order with logistiq partner?',
          icon: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#ee3a7a',
          confirmButtonText:
            i18n.yes,
          cancelButtonText:
            i18n.cancel
        }).then(result => {
          if (result.value) {
            this.orderAction.emit({ uuid: uuid, action: action });
          }
        });
        break;
    }
  }

  orderHistory(action, uuid) {
    this.loaderService.startLoading();
    this.orderService.getStatuses(uuid).subscribe(data => {
      this.loaderService.stopLoading();
      const orderModalRef = this.modalService.open(OrderHistoryComponent);
      orderModalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "order-history-modal";
      orderModalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.classList.add("orderhistory-modal");
      orderModalRef.componentInstance.order = data;
      orderModalRef.result.then(data => {

      }, fallbackResult => {

      })
    }, err => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
    });
  }

  orderWithOto(uuid) {
    this.loaderService.startLoading();
    this.orderService.getOrder(uuid).subscribe(data => {
      this.loaderService.stopLoading();

      const orderModalRef = this.modalService.open(OrderOtoComponent);
      orderModalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "recordpayment";
      // orderModalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "order-history-modal";
      // orderModalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.classList.add("orderhistory-modal");
      orderModalRef.componentInstance.order = data;
      orderModalRef.result.then(data => {
        if (data) {
          window.location.reload();
        }
      }, fallbackResult => {

      })
    }, err => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
    });
  }

  orderShipmentWithOto(uuid) {
    Swal.fire({
      text: 'Create order shipment on OTO',
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: '#ee3a7a',
      confirmButtonText:
        i18n.yes,
      cancelButtonText:
        i18n.cancel
    }).then(result => {
      if (result.value) {
        this.loaderService.startLoading();
        this.orderService.createShipmentOnOto(uuid).subscribe((data: any) => {
          this.loaderService.stopLoading();
          Swal.fire(i18n.done, data.message, 'success');
        }, err => {
          this.loaderService.stopLoading();
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        })
      }
    });
  }

  copyAddress(order: any) {
    try {
      let fullAddress = order.full_address;
      let latitude = order.location.latitude;
      let longitude = order.location.longitude;
      let location = "https://maps.google.com/maps?q="+latitude+","+longitude;
      let copyDate = i18n.order.order_number+" : "+order.order_number+"\n"+i18n.order.customer_info+" : "+order.client_name+" "+order.client_phone+"\n"+i18n.order.delivery_info+" : "+order.full_address+"\n"+i18n.order.location+" : "+location;
      if (order.attachment) {
        copyDate += "\n"+i18n.order.location_attachment+" : "+order.attachment;
      }
      this.clipboard.copy(copyDate);
      Swal.fire(i18n.done, i18n.order.address_copied_to_clipboard, 'success');
    } catch (err) {
      console.error(err);
    }
  }

  viewInvoice() {
    this.router.navigate(['/invoices'], { queryParams: { 'uuid': this.order.invoice_uuid } });
  }

  transStatus(status : string) {
    return i18n.t(status.toLowerCase());
  }

  goBackToListing() {
    this.selectedOrder.emit(null);
  }
}
